"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSignaturePayload = exports.EncryptedGroupKey = exports.GroupKeyResponse = exports.GroupKeyRequest = exports.GroupKeyMessage = exports.StreamMessageType = exports.StreamMessage = exports.MessageRef = exports.MessageID = void 0;
const MessageID_1 = __importDefault(require("./MessageID"));
exports.MessageID = MessageID_1.default;
const MessageRef_1 = __importDefault(require("./MessageRef"));
exports.MessageRef = MessageRef_1.default;
const StreamMessage_1 = __importDefault(require("./StreamMessage"));
exports.StreamMessage = StreamMessage_1.default;
const StreamMessage_2 = require("./StreamMessage");
Object.defineProperty(exports, "StreamMessageType", { enumerable: true, get: function () { return StreamMessage_2.StreamMessageType; } });
const GroupKeyRequest_1 = __importDefault(require("./GroupKeyRequest"));
exports.GroupKeyRequest = GroupKeyRequest_1.default;
const GroupKeyResponse_1 = __importDefault(require("./GroupKeyResponse"));
exports.GroupKeyResponse = GroupKeyResponse_1.default;
const EncryptedGroupKey_1 = __importDefault(require("./EncryptedGroupKey"));
exports.EncryptedGroupKey = EncryptedGroupKey_1.default;
const signature_1 = require("./signature");
Object.defineProperty(exports, "createSignaturePayload", { enumerable: true, get: function () { return signature_1.createSignaturePayload; } });
__exportStar(require("./StreamMessage"), exports);
// Serializers are imported because of their side effects: they statically register themselves to the factory class
require("./StreamMessageSerializerV32");
const GroupKeyMessage_1 = __importDefault(require("./GroupKeyMessage"));
exports.GroupKeyMessage = GroupKeyMessage_1.default;
//# sourceMappingURL=index.js.map